// @ts-nocheck
import React, { useContext, useReducer } from 'react'
import AlertContext from './AlertContext'
import AlertReducer from '../reducers/alertReducer'
import uuid from "uuid";
import {
    SET_ALERT,
    REMOVE_ALERT,
    ALERT_INFO,
    ALERT_ERROR,
    ALERT_WARNING
} from '../types/General/alertActionType'

const AlertState = props => {
    const initialState = [];
    const [state, dispatch] = useReducer(AlertReducer, initialState)

    //Set Alert
    const setAlert = (message, timeout = 5000, type = ALERT_INFO) => {
        const id = uuid.v4();
        dispatch({
            type: SET_ALERT,
            payload:
            {
                id,
                message,
                shown: false,
                timeout,
                type
            }
        })

        setTimeout(() => {
            dispatch({
                type: REMOVE_ALERT,
                payload:id
            })
        }, timeout);
    }



    return <AlertContext.Provider
        value={
            {
                alerts: state,
                setAlert
            }
        }
    >
        {props.children}
    </AlertContext.Provider>
}

export default AlertState;

export const useAlert=()=>{
    const context=useContext(AlertContext);
    const {setAlert}=context;

    const splitMessage=(message)=>{
        return [message]
    }


    const setAlertError=(message, timeout = 5000)=>{
        splitMessage(message).forEach(e=>
                setAlert(e,timeout,ALERT_ERROR)
            )
    };

    const setAlertWarnning= (message, timeout = 5000)=>{
        splitMessage(message).forEach(e=>
            setAlert(e,timeout,ALERT_WARNING)
        )
        
    };



    return {context,setAlert,setAlertError,setAlertWarnning}
}

// // @ts-nocheck
// import React, { useReducer } from 'react'
// import AlertContext from './AlertContext'
// import AlertReducer from '../reducers/alertReducer'
// import uuid from "uuid";
// import {
//     SET_ALERT,
//     REMOVE_ALERT,
//     ALERT_INFO
// } from '../types/General/alertActionType'

// const AlertState = props => {
//     const initialState = [];
//     const [state, dispatch] = useReducer(AlertReducer, initialState)

//     //Set Alert
//     const setAlert = (message, timeout = 5000, type = ALERT_INFO) => {
//         const id = uuid.v4();
//         dispatch({
//             type: SET_ALERT,
//             payload:
//             {
//                 id,
//                 message,
//                 shown: false,
//                 timeout,
//                 type
//             }
//         })

//         setTimeout(() => {
//             dispatch({
//                 type: REMOVE_ALERT,
//                 payload:id
//             })
//         }, timeout);
//     }



//     return <AlertContext.Provider
//         value={
//             {
//                 alerts: state,
//                 setAlert
//             }
//         }
//     >
//         {props.children}
//     </AlertContext.Provider>
// }

// export default AlertState;